<template>
  <div class="market-wrap pt-4">
    <b-container>
      <b-sidebar
        id="sb-filter-nft"
        title="SELECT ATTRIBUTES"
        backdrop
        shadow
        text-variant="light"
        body-class="sb-body"
      >
        <template>
          <div>
            <div class="container">
              <div
                class="is-flex"
                v-b-toggle="`collapse-nft`"
                style="justify-content: space-between"
              >
                <div>Your NFTs</div>
                <div>
                  <b-icon-chevron-down></b-icon-chevron-down>
                </div>
              </div>
            </div>
            <hr />
            <b-collapse visible id="collapse-nft" class="mt-2">
              <b-container>
                <div
                  v-for="it in oNfts"
                  :key="it.value"
                  class="is-flex"
                  style="justify-content: space-between"
                >
                  <div>
                    <b-form-group>
                      <b-form-checkbox
                        v-model="oNftType[it.value]"
                        @change="onChangeNft(it.value)"
                        switch
                        ><span>{{ it.text }}</span></b-form-checkbox
                      >
                    </b-form-group>
                  </div>
                </div>
              </b-container>
            </b-collapse>
          </div>
          <div v-for="(trait, key) in Object.keys(stats)" :key="key">
            <div class="container">
              <div
                class="is-flex"
                v-b-toggle="`collapse-${trait}`"
                style="justify-content: space-between"
              >
                <div>
                  {{ trait.toUpperCase() }}
                </div>
                <div>
                  <b-icon-chevron-down></b-icon-chevron-down>
                </div>
              </div>
            </div>
            <hr />
            <b-collapse
              :visible="key === 0"
              :id="`collapse-${trait}`"
              class="mt-2"
            >
              <b-container>
                <div
                  v-for="(it, k) in Object.keys(stats[trait])"
                  :key="k"
                  class="is-flex"
                  style="justify-content: space-between"
                >
                  <div>
                    <b-form-group>
                      <b-form-checkbox
                        switch
                        v-model="filters[trait][it]"
                        v-on:change="
                          selects.push([trait, it, filters[trait][it]])
                        "
                        ><span>{{ it }}</span></b-form-checkbox
                      >
                    </b-form-group>
                  </div>
                  <div>{{ stats[trait][it] }} items</div>
                </div>
              </b-container>
            </b-collapse>
          </div>
        </template>
        <template #footer="{ hide }">
          <div class="fsider-bar d-flex justify-content-center py-2">
            <b-button class="btn-custom btn-cancel mr-2 px-4" @click="hide()">
              Close
            </b-button>
            <b-button
              class="ml-2 btn-custom btn-success"
              @click="handleFilterOk()"
            >
              Apply
            </b-button>
          </div>
        </template>
      </b-sidebar>
      <div
        class="is-flex space-between saru-tab justify-content-between align-items-center hide"
      >
        <div class="d-flex">
          <div
            :class="`collection-name px-4 ${nft === nftSaru ? 'active' : ''}`"
            @click="onChangeTab(nftSaru)"
          >
            saru
          </div>
          <div
            :class="`collection-name px-4 ${nft === nftItem ? 'active' : ''}`"
            @click="onChangeTab(nftItem)"
          >
            item
          </div>
        </div>
        <!-- <h1 class="collection-name" v-if="nftName">
                  <span>{{ nftName }}</span>
              </h1>                 -->
        <!-- <b-skeleton v-else width="20%" height="40px"></b-skeleton> -->
        <ul class="social-list">
          <li class="item" v-if="(nftInfo.links || {}).website">
            <a :href="(nftInfo.links || {}).website">
              <svg
                class="network"
                width="40"
                height="40"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 26C5.8201 26 0 20.1799 0 13C0 5.8201 5.8201 0 13 0C20.1799 0 26 5.8201 26 13C26 20.1799 20.1799 26 13 26ZM21.2615 18.1376V18.0011C21.2615 16.8025 21.2615 16.2552 20.4139 15.7703C20.1415 15.6159 19.8616 15.4749 19.5754 15.3478C19.0983 15.1307 18.7824 14.989 18.356 14.365C18.3051 14.2909 18.2548 14.2164 18.2052 14.1414C17.7567 13.4589 17.433 12.9675 16.2006 13.1625C13.7761 13.5473 13.5967 13.9737 13.4901 14.6939L13.4732 14.8122C13.3159 15.8652 13.2873 16.2188 13.7267 16.6803C15.3712 18.4054 16.3566 19.6495 16.6556 20.3775C16.8012 20.7324 17.1756 21.8075 16.9182 22.8709C18.4962 22.2424 19.9007 21.2452 21.0145 19.9628C21.1575 19.4766 21.2615 18.8708 21.2615 18.1376ZM13 2.3829C9.9879 2.3829 7.267 3.6387 5.3352 5.6537C5.5653 5.8136 5.7655 6.0385 5.9033 6.3479C6.1685 6.942 6.1685 7.5543 6.1685 8.0964C6.1685 8.5228 6.1685 8.9284 6.305 9.2209C6.4922 9.6213 7.3008 9.7929 8.0145 9.9411C8.2706 9.9957 8.5332 10.0503 8.7724 10.1166C9.4302 10.2986 9.9398 10.8901 10.3467 11.3646C10.5157 11.5609 10.7666 11.8508 10.8927 11.9236C10.9577 11.8768 11.167 11.6493 11.2697 11.2762C11.3503 10.9902 11.3269 10.738 11.2112 10.6002C10.4832 9.7422 10.5235 8.0912 10.7484 7.4815C11.102 6.5208 12.207 6.5923 13.0156 6.6443C13.3172 6.6638 13.6006 6.6833 13.8138 6.656C14.6224 6.5546 14.872 5.3235 15.0475 5.083C15.4271 4.563 16.5893 3.7791 17.3095 3.2955C15.9529 2.69229 14.4846 2.38135 13 2.3829Z"
                  fill="#B3BAC5"
                />
              </svg>
            </a>
          </li>
          <li class="item" v-if="(nftInfo.links || {}).telegram">
            <a :href="(nftInfo.links || {}).telegram">
              <svg
                class="telegram"
                width="40"
                height="40"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 26C5.8201 26 0 20.1799 0 13C0 5.8201 5.8201 0 13 0C20.1799 0 26 5.8201 26 13C26 20.1799 20.1799 26 13 26ZM8.957 14.521L8.9739 14.5119L10.1049 18.2429C10.2505 18.6472 10.4507 18.72 10.6938 18.6862C10.9382 18.6537 11.0669 18.5224 11.2268 18.369L12.7712 16.8766L16.0862 19.331C16.692 19.6651 17.1275 19.4922 17.2783 18.7694L19.4324 8.6008C19.6703 7.6544 19.2543 7.2748 18.5198 7.5764L5.8669 12.4644C5.0037 12.8102 5.0089 13.2938 5.7109 13.5083L8.957 14.5223V14.521Z"
                  fill="#B3BAC5"
                />
              </svg>
            </a>
          </li>
          <!-- <li class="item" v-if="(nftInfo.links || {}).twitter">
                      <a :href="(nftInfo.links || {}).twitter">
                          <svg class="twitter" width="40" height="40" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="13" cy="13" r="13"/>
                              <g clip-path="url(#clip0_77:789)">
                              <path d="M19.6052 8.87638C19.1089 9.09588 18.5827 9.24003 18.0439 9.30408C18.6118 8.96441 19.0369 8.42984 19.2399 7.79998C18.7069 8.11718 18.1225 8.33948 17.5135 8.45973C17.1043 8.022 16.5621 7.7317 15.971 7.63396C15.3799 7.53621 14.773 7.6365 14.2448 7.91922C13.7165 8.20195 13.2965 8.65127 13.05 9.19734C12.8034 9.74341 12.7442 10.3556 12.8816 10.9388C11.8007 10.8847 10.7433 10.6038 9.77799 10.1144C8.81271 9.62505 7.96113 8.93816 7.27855 8.09833C7.03694 8.51332 6.90997 8.98507 6.91065 9.46528C6.91065 10.4078 7.39035 11.2404 8.11965 11.7279C7.68806 11.7143 7.26596 11.5978 6.88855 11.388V11.4218C6.88868 12.0495 7.10589 12.6578 7.50335 13.1437C7.90081 13.6295 8.45406 13.9629 9.0693 14.0874C8.66865 14.196 8.24855 14.212 7.8408 14.1342C8.01426 14.6745 8.35236 15.1471 8.80774 15.4856C9.26312 15.8242 9.81298 16.0119 10.3804 16.0225C9.81646 16.4653 9.17082 16.7927 8.48032 16.9859C7.78983 17.1791 7.06803 17.2342 6.3562 17.1483C7.5988 17.9474 9.04531 18.3717 10.5227 18.3703C15.5232 18.3703 18.2577 14.2278 18.2577 10.6353C18.2577 10.5183 18.2545 10.4 18.2493 10.2843C18.7815 9.89959 19.2409 9.42304 19.6058 8.87703L19.6052 8.87638Z" fill="white"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_77:789">
                              <rect width="15.6" height="15.6" fill="white" transform="translate(5.19995 5.19995)"/>
                              </clipPath>
                              </defs>
                          </svg>
                      </a>
                  </li>
                  <li id="my-nft" v-if="!isConnect">
                      <a @click="$bvModal.show('your-nft')">
                          <b-icon-person-circle></b-icon-person-circle> <span class="lbl-nft">Your NFTs</span>
                      </a>
                  </li> -->
        </ul>
      </div>
      <div class="pt-3 pb-3">
        <b-row class="is-multiline mb-3 hide">
          <b-col class="is-flex space-between">
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size">Currency </b-card-text>
              <b-card-text class="v-size" v-if="!loadingData">{{
                ftSymbol
              }}</b-card-text>
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size">Supply</b-card-text>
              <b-card-text class="v-size" v-if="!loadingData">{{
                utils.numberToCommon(cSupply, 0)
              }}</b-card-text>
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size">TVL </b-card-text>
              <b-card-text class="v-size" v-if="!loadingData">{{
                utils.bigToLabel(tvl, ftDecimals, 2)
              }}</b-card-text>
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size">Market Price </b-card-text>
              <b-card-text class="v-size" v-if="!loadingData">{{
                utils.bigToLabel(bestBidMarketPrice, ftDecimals, 2)
              }}</b-card-text>
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size">ROI</b-card-text>
              <b-card-text class="v-size" v-if="!loadingData"
                >{{ roi }}%</b-card-text
              >
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size"
                >Withdraw Fee
                <b-icon
                  icon="info-circle"
                  v-b-tooltip.click.top="
                    'The percent of the withdrawal amount you have to pay back the pool'
                  "
                ></b-icon
              ></b-card-text>
              <b-card-text class="v-size" v-if="!loadingData"
                >{{ utils.feeToCommon(withdrawFee) }}%
              </b-card-text>
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size">Exchange Fee </b-card-text>
              <b-card-text class="v-size" v-if="!loadingData"
                >{{ utils.feeToCommon(exchangeFee) }}%</b-card-text
              >
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
            <b-card class="card-item mb-2 py-3 px-2" align="center" no-body>
              <b-card-text class="mb-0 t-size"
                >Treasury
                <b-icon
                  icon="info-circle"
                  v-b-tooltip.click.top="
                    'The percent of the exchange fee that sends to the treasury wallet'
                  "
                ></b-icon
              ></b-card-text>
              <b-card-text class="v-size" v-if="!loadingData"
                >{{ utils.feeToCommon(treasuryFee) }}%</b-card-text
              >
              <b-card-text v-else><b-skeleton></b-skeleton></b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="is-multiline filter-wrap" v-if="allData.length > 0">
          <b-col class="is-flex space-between">
            <div class="is-flex space-between group-filter align-items-center">
              <b-button v-b-toggle.sb-filter-nft class="filter-button">
                FILTERS
                <b-icon-filter></b-icon-filter>
              </b-button>
              <div class="search-input w-100">
                <span class="icon-search"><b-icon-search></b-icon-search></span>
                <b-form-input
                  placeholder="SEACH NAME, OWNER"
                  type="search"
                  id="search-nft"
                  v-model="search"
                  v-on:change="handleSearch()"
                ></b-form-input>
              </div>
              <div class="w-100 d-flex flex-row">
                <b-form-select
                  class="sort w-100"
                  v-model="selected"
                  :options="options"
                  @change="handleSort()"
                  plain
                >
                </b-form-select>
                <div
                  class="ml-2 d-flex border rounded px-2 justify-content-center align-items-center sort-type align-self-center"
                  @click.prevent="handleSort(orSelected)"
                >
                  <b-icon
                    class="h3"
                    :icon="`sort-${orSelected === 'L2H' ? 'up' : 'down'}`"
                    variant="light"
                  ></b-icon>
                </div>
              </div>
            </div>
            <div class="icon-position">
              <div class="is-flex space-between grid-layout">
                <b-input-group-text
                  v-on:click="addClass1"
                  :class="{ active: isAddClass1 }"
                >
                  <b-icon-grid-fill></b-icon-grid-fill>
                </b-input-group-text>
                <b-input-group-text
                  v-on:click="addClass2"
                  :class="{ active: isAddClass2 }"
                >
                  <b-icon-grid3x3-gap-fill></b-icon-grid3x3-gap-fill>
                </b-input-group-text>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row
          class="is-multiline filter-wrap mb-3"
          v-if="allData.length === 0 && loadingData"
        >
          <b-col class="is-flex space-between">
            <div class="is-flex space-between group-filter">
              <b-button class="filter-button">
                <b-skeleton type="button" width="100px"></b-skeleton>
              </b-button>
              <div class="custom-sekeleton-input search-input">
                <b-skeleton type="input"></b-skeleton>
              </div>
              <div class="custom-sekeleton-input select-input">
                <b-skeleton type="input"></b-skeleton>
              </div>
            </div>
            <div class="icon-position">
              <div class="is-flex space-between grid-layout">
                <b-input-group-text
                  v-on:click="addClass1"
                  :class="{ active: isAddClass1 }"
                >
                  <b-skeleton type="button" width="56px"></b-skeleton>
                </b-input-group-text>
                <b-input-group-text
                  v-on:click="addClass2"
                  :class="{ active: isAddClass2 }"
                >
                  <b-skeleton type="button" width="56px"></b-skeleton>
                </b-input-group-text>
              </div>
            </div>
          </b-col>
        </b-row>
        <div
          class="mb-4 mt-4 is-flex space-between"
          v-if="!loadingData && allData.length > 0"
        >
          <div class="atribute-filter is-flex">
            <span v-for="k in Object.keys(filters)" :key="k">
              <span v-for="(v, b) in Object.keys(filters[k])" :key="b">
                <b-form-tag
                  class="mr-1 badge-custom"
                  v-if="filters[k][v]"
                  @remove="
                    filters[k][v] = false;
                    handleFilterOk();
                  "
                  >{{ `${k.toUpperCase()}:${v}` }}</b-form-tag
                >
              </span>
            </span>
            <b-form-tag
              class="mr-1 badge-custom"
              v-if="search"
              @remove="
                search = '';
                handleFilterOk();
              "
              >{{ `SEARCH:${search}` }}</b-form-tag
            >
            <b-link
              type="link"
              class="filter-clear is-flex"
              v-if="totalSupply !== totalResults"
              @click="clearTag()"
              style="align-items: center"
            >
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  fill="currentColor"
                  class="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                  />
                </svg>
                <span v-if="!loadingItems">Clear All</span>
              </div>
            </b-link>
          </div>
          <span class="result" v-if="!loadingItems"
            >{{ totalResults }} results</span
          >
        </div>
        <div class="pb-4 mt-4 is-flex space-between" v-if="loadingData">
          <b-skeleton animation="fade" width="100%"></b-skeleton>
        </div>
        <b-row class="is-multiline" v-bind:class="`${classActive}`">
          <b-col v-if="items.length > 0" class="is-flex">
            <b-card
              v-for="it in items"
              :key="it.code"
              no-body
              :href="`/${it.id}`"
              class="nft-item"
            >
              <span class="top-icon"></span>
              <router-link :to="`/marketplace/${nft}/${it.tokenId}`">
                <b-card-img
                  class="nft-image"
                  :class="{ pixelated: isPixelated }"
                  v-bind:src="
                    utils.nftIpfsLink(it.image) ||
                    `data:image/svg+xml;charset=UTF-8,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' preserveAspectRatio='none'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%23holder_17cb7089c7d text %7B fill:'%23DFE1E6';font-weight:bold;font-family:Poppins, monospace;font-size:50pt %7D %3C/style%3E%3C/defs%3E%3Cg id='holder_17cb7089c7d'%3E%3Crect width='200' height='200' fill='%23EBECF0'%3E%3C/rect%3E%3Cg%3E%3Ctext x='44.421875' y='118.5' fill='%23DFE1E6'%3E%23${it.tokenId}%3C/text%3E%3C/g%3E%3C/g%3E%3C/svg%3E`
                  "
                  alt="image"
                ></b-card-img>
                <b-card-body class="is-flex">
                  <div class="nft-head">
                    <b-card-text class="nft-acc">{{ nftName }}</b-card-text>
                    <b-card-title class="nft-title">{{
                      utils.truncate(it.name || `${nftName} #${it.tokenId}`, 11)
                    }}</b-card-title>
                  </div>
                  <div class="nft-price" v-if="!it.price.value.eq(0)">
                    <b-card-text class="nft-price-text"
                      >{{ it.price.label }}({{ ftSymbol }})</b-card-text
                    >
                    <b-card-title class="nft-price-value">{{
                      utils.bigToLabel(it.price.value, ftDecimals, 2)
                    }}</b-card-title>
                  </div>
                </b-card-body>
              </router-link>
            </b-card>
          </b-col>
          <!-- Skeleton loading -->
          <b-col v-if="items.length === 0 && loadingItems" class="is-flex">
            <b-card
              v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
              :key="i"
              no-body
              class="nft-item"
            >
              <span class="top-icon"></span>
              <a>
                <b-skeleton-img></b-skeleton-img>
                <b-card-body class="is-flex space-between">
                  <div class="nft-head">
                    <b-skeleton animation="fade" width="50px"></b-skeleton>
                    <b-skeleton animation="fade" width="100%"></b-skeleton>
                  </div>
                  <div class="nft-price" style="width: auto">
                    <b-skeleton animation="fade" width="60px"></b-skeleton>
                    <b-skeleton animation="fade" width="30px"></b-skeleton>
                  </div>
                </b-card-body>
              </a>
            </b-card>
          </b-col>
          <div class="no-item" v-if="items.length === 0 && !loadingItems">
            <p><b-img :src="require('@/assets/images/nologo.svg')"></b-img></p>
            <p class="msg">NFTs will be show here.</p>
          </div>
          <!-- End skeleton loading -->
        </b-row>
      </div>
      <div
        v-if="loadingItems && 1 < page && limit * page < totalResults"
        class="text-center pb-3"
      >
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>
      <div>
        <b-modal
          id="filter-nft"
          no-close-on-backdrop
          centered
          scrollable
          title="Select attributes"
          @ok="handleFilterOk()"
          @cancel="handleFilterCancel()"
        >
          <template>
            <div v-for="(trait, key) in Object.keys(stats)" :key="key">
              <div class="container">
                <div
                  class="is-flex"
                  v-b-toggle="`collapse-${trait}`"
                  style="justify-content: space-between"
                >
                  <div>
                    {{ trait.toUpperCase() }}
                  </div>
                  <div>
                    <b-icon-chevron-down></b-icon-chevron-down>
                  </div>
                </div>
              </div>
              <hr />
              <b-collapse
                :visible="key === 0"
                :id="`collapse-${trait}`"
                class="mt-2"
              >
                <b-container>
                  <div
                    v-for="(it, k) in Object.keys(stats[trait])"
                    :key="k"
                    class="is-flex"
                    style="justify-content: space-between"
                  >
                    <div>
                      <b-form-group>
                        <b-form-checkbox
                          switch
                          v-model="filters[trait][it]"
                          v-on:change="
                            selects.push([trait, it, filters[trait][it]])
                          "
                          ><span>{{ it }}</span></b-form-checkbox
                        >
                      </b-form-group>
                    </div>
                    <div>{{ stats[trait][it] }} items</div>
                  </div>
                </b-container>
              </b-collapse>
            </div>
          </template>

          <template #modal-footer="{ ok, cancel }">
            <b-button class="btn-custom btn-cancel mr-1" @click="cancel()">
              Cancel
            </b-button>
            <b-button class="btn-custom btn-success" @click="ok()">
              OK
            </b-button>
          </template>
        </b-modal>
      </div>
    </b-container>
    <b-modal
      id="import-token-alert"
      no-close-on-backdrop
      centered
      hide-footer
      title="Import tokens"
    >
      <ImportTokenAlert
        @import-success="$bvModal.hide('import-token-alert')"
        :tokens="{ ft: ft, nft: nft }"
      />
    </b-modal>
    <b-modal
      id="your-nft"
      size="xl"
      scrollable
      centered
      hide-footer
      title="Your NFTs"
    >
      <YourNFT
        :ftLink="ftLink"
        :nftAddress="nft"
        :ftSymbol="ftSymbol"
        :nftSymbol="nftSymbol"
        @nft-success="$bvModal.hide('your-fnt')"
      />
    </b-modal>
    <b-modal
      id="liquidity"
      scrollable
      centered
      hide-footer
      title="Liquidity"
      @close="
        isBidMarket = false;
        isWithdraw = false;
      "
      @hide="
        isBidMarket = false;
        isWithdraw = false;
      "
    >
      <Liquidity
        v-if="!isBidMarket && !isWithdraw"
        :ftLink="ftLink"
        :nftAddress="nft"
        :ftSymbol="ftSymbol"
        :ftDecimals="ftDecimals"
        :lpShare="lpShare"
        :lpPrice="lpPrice"
        :lpIsAuto="lpIsAuto"
        :lpROI="lpROI"
        @add-liquidity="isBidMarket = true"
        @withdraw="isWithdraw = true"
      />
      <BidMarket
        v-if="isBidMarket"
        :ftLink="ftLink"
        :nftAddress="nft"
        @bid-market-success="
          getMarketInfo().then(() => $bvModal.hide('liquidity'))
        "
        @bid-market-cancel="$bvModal.hide('liquidity')"
      />
      <Withdraw
        v-if="isWithdraw"
        :lpShare="lpShare"
        :ftLink="ftLink"
        :nftAddress="nft"
        @withdraw-success="
          getMarketInfo().then(() => $bvModal.hide('liquidity'))
        "
        @withdraw-cancel="$bvModal.hide('liquidity')"
      />
    </b-modal>
    <b-toast
      id="tx-confirm"
      toast-class="b-info"
      title="Transaction Process"
      solid
      no-auto-hide
    >
      Your transaction is being processed.
    </b-toast>
    <b-toast
      id="tx-success"
      toast-class="b-success"
      title="Transaction Success"
      solid
      auto-hide-delay="8000"
    >
      Your transaction is successful.
    </b-toast>
  </div>
</template>
<script>
import axios from "axios";
import utils from "@/utils";
import { ethers } from "ethers";
import { Market, Multicall, NFT } from "@bazarion/sdk";
import store from "@/utils/stores";
import ImportTokenAlert from "./ImportTokenAlert.vue";
import YourNFT from "./YourNFT.vue";
import Liquidity from "./Liquidity.vue";
import BidMarket from "./BidMarket.vue";
import Withdraw from "./Withdraw.vue";
import urljoin from "url-join";
import config from "@/config";
import saruData from "@/assets/kuni-saru-stats.json";
// import * as _ from 'lodash';

const options = [
  { value: "ID", text: "ID" },
  { value: "P", text: "Price" },
  { value: "O", text: "Offer" },
  {
    label: "Efficiency",
    options: [
      { value: "stats.efficiency.ore", text: "Ore" },
      { value: "stats.efficiency.stone", text: "Stone" },
      { value: "stats.efficiency.fiber", text: "Cotton" },
      { value: "stats.efficiency.wood", text: "Lumber" },
    ],
  },
  {
    label: "Battle Power",
    options: [
      { value: "stats.power.total", text: "Total" },
      { value: "stats.power.slash", text: "Slash" },
      { value: "stats.power.heavy", text: "Heavy" },
      { value: "stats.power.strike", text: "Strike" },
      { value: "stats.power.tech", text: "Tech" },
      { value: "stats.power.magic", text: "Magic" },
    ],
  },
  {
    label: "Battle Attack",
    options: [
      { value: "stats.attack.slash", text: "Slash" },
      { value: "stats.attack.heavy", text: "Heavy" },
      { value: "stats.attack.strike", text: "Strike" },
      { value: "stats.attack.tech", text: "Tech" },
      { value: "stats.attack.magic", text: "Magic" },
    ],
  },
  {
    label: "Battle Defend",
    options: [
      { value: "stats.defend.slash", text: "Slash" },
      { value: "stats.defend.heavy", text: "Heavy" },
      { value: "stats.defend.strike", text: "Strike" },
      { value: "stats.defend.tech", text: "Tech" },
      { value: "stats.defend.magic", text: "Magic" },
    ],
  },
  //   { value: "stats.efficiency.hide", text: "Leather Eficiency" },
];

const optionItems = [
  { value: "ID", text: "ID" },
  { value: "P", text: "Price" },
  { value: "O", text: "Offer" },
  { value: "total", text: "Battle Power Total" },
  { value: "slash", text: "Battle Power Slash" },
  { value: "heavy", text: "Battle Power Heavy" },
  { value: "strike", text: "Battle Power Strike" },
  { value: "tech", text: "Battle Power Tech" },
  { value: "magic", text: "Battle Power Magic" },
];

export default {
  components: {
    ImportTokenAlert,
    Liquidity,
    Withdraw,
    BidMarket,
    YourNFT,
  },
  computed: {
    nftTabSelected: function () {
      return this.$store.getters["auth/nftTabCurrent"];
    },
  },
  data: () => ({
    oFilter: [],
    oNftType: {},
    nft: "",
    nftItem: "",
    pets: [],
    selected: "P",
    orSelected: "L2H",
    orders: [
      { value: "L2H", text: "Low to High" },
      { value: "H2L", text: "High to Low" },
    ],
    oNfts: [
      { value: "yourNft", text: "In Wallet" },
      { value: "ask", text: "Asks" },
      { value: "bid", text: "Bids" },
    ],
    options: [],
    currencySelected: "BAZA",
    currencyOptions: [{ value: "BAZA", text: "Currency: BAZA" }],
    ft: "",
    ftLink: "",
    nftSymbol: "",
    ftSymbol: "",
    nftName: "",
    sFt: "",
    sNft: "",
    market: "",
    tokenNfts: [],
    tokenFts: [],
    isCreate: false,
    totalSupply: 0,
    cSupply: 0,
    exchangeFee: 0,
    withdrawFee: 0,
    treasuryFee: 0,
    stakeRate: 0,
    bestBidMarketPrice: ethers.BigNumber.from(0),
    tvl: 0,
    roi: 0,
    items: [],
    ftDecimals: 18,
    page: 1,
    limit: 12,
    loadingItems: true,
    loadingData: true,
    isNative: false,
    stats: {},
    filters: {},
    allData: [],
    result: [],
    filterResult: {},
    askPrices: {},
    bidPrices: {},
    search: "",
    selects: [],
    nftInfo: {},
    isAddClass1: false,
    isAddClass2: true,
    classActive: "columns-4",
    totalResults: 0,
    isPixelated: false,
    isBidMarket: false,
    isWithdraw: false,
    isConnect: false,
    lpPrice: ethers.BigNumber.from(0),
    lpShare: ethers.BigNumber.from(0),
    lpROI: 0,
    lpIsAuto: false,
  }),
  updated: async function () {
    this.$nextTick().then(() => {
      setTimeout(() => {
        let nftImg = document.querySelector(".nft-item");
        if (nftImg) {
          if (nftImg.naturalWidth < 200) {
            this.isPixelated = true;
          } else {
            this.isPixelated = false;
          }
        }
      }, 5000);
    });
  },
  created: async function () {
    let { ft, nft, chainId, kuniItem } = this.getCoreConfig();
    this.chainId = chainId;
    this.ftLink = ft;
    this.nftItem = kuniItem;
    this.nftSaru = nft;
    this.options = options;
    if (this.nftTabSelected) {
      this.nft = this.nftTabSelected;
    }
    if (nft && !this.nft) {
      this.nft = nft;
    }
    try {
      this.provider = await this.getProvider();
      this.isConnect = this.provider.connection.url !== "metamask";
      this.address = await this.provider.getSigner().getAddress();
    } catch (e) {
      this.isConnect = true;
    }

    this.initNft();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async initNft() {
      let { ft } = this.getCoreConfig();
      this.ftLink = ft;
      this.provider = await this.getProvider(this.chainId);
      this.market = await Market.setMarket(ft, this.nft, this.provider);
      this.nft = ethers.utils.getAddress(this.market.nft);
      this.ft = ethers.utils.getAddress(this.market.ft);
      this.isNative = this.market.isNative;
      this.marketAddress = this.market.market;
      this.cNft = new NFT(this.nft, this.provider);
      let tokens = store.getTokens();

      this.nftInfo =
        tokens.find(
          (t) => t.address === this.nft && t.chainId === this.chainId
        ) || {};

      await this.getMarketInfo();
      // let b = this.utils.checkTokenAlert(this.chainId, this.ft, this.nft)
      // if (b) {
      // this.$bvModal.show('import-token-alert')
      // }
      await this.getData();
      if (this.allData.length > 0) {
        this.search = this.$route.query.s || "";
        this.selected = this.$route.query.srt || this.selected;
        this.orSelected = this.$route.query.o || this.orSelected;
        let flt = JSON.parse(this.$route.query.flt || "{}");
        Object.keys(flt || {}).forEach((k) => {
          Object.keys(flt[k]).forEach((kk) => {
            this.filters[k][kk] = flt[k][kk];
          });
        });
      }

      await this.handleFilterOk();
      this.loadingData = false;
      this.loadingItems = false;
    },
    async getYourNfts() {
      const total = (await this.cNft.balanceOf(this.address)).toNumber();
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let nfts = await calls.nftOfOwnerByIndex(this.address, 0, total);
      return nfts.map((i) => `${i}`);
    },
    async getBids() {
      const total = (await this.market.bidBalanceOf(this.address)).toNumber();
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let nfts = await calls.bidOfOwnerByIndex(this.address, 0, total);
      return nfts.map((i) => `${i}`);
    },
    async getAsks() {
      const total = (await this.market.askBalanceOf(this.address)).toNumber();
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let nfts = await calls.askOfOwnerByIndex(this.address, 0, total);
      return nfts.map((i) => `${i}`);
    },
    getData: async function () {
      try {
        let data = saruData;
        if (this.nft === this.nftItem) {
          try {
            data = {
              data: [],
              totalSupply: 0,
              stats: {},
            };
            // let rs = await axios.get(urljoin(config.apiBaseUrl, `/api/${this.chainId}/data/${this.nft}/all`))
            let rs = await axios.get(
              urljoin(config.amaBaseUrl, `/api/kuni-items?token=${this.nft}`)
            );
            if (rs.data) {
              data = {
                data: (rs.data || []).map((it) => {
                  let total = 0;
                  for (const t of it.attributes) {
                    const val = Number(t.value);
                    total += val;
                    it[t.trait_type] = val;
                  }
                  it.total = total;
                  return it;
                }),
                totalSupply: rs.data.length,
                stats: {},
              };
            }
          } catch {
            // eslint-disable-next-line
                  }
        }

        // let { data } =await axios.get(urljoin(config.apiBaseUrl, `/api/56/data/0x5fa891e95c948288A376C92fbd3AFc83D488d5a8/all`))
        this.stats = data.stats;
        this.filters = Object.keys(this.stats).reduce(
          (a, v) => ({ ...a, [v]: {} }),
          {}
        );
        this.allData = data.data;

        const yourNfts = await this.getYourNfts();
        const asks = await this.getAsks();
        const bids = await this.getBids();
        this.allData = this.allData.map((item) => {
          item.yourNft = yourNfts.includes(item.id);
          item.bid = bids.includes(item.id);
          item.ask = asks.includes(item.id);
          return item;
        });
        this.totalSupply =
          this.totalSupply < this.allData.length
            ? this.allData.length
            : this.totalSupply;
      } catch (e) {
        // eslint-disable-next-line
          }
      try {
        let { data } = await axios.get(
          urljoin(
            config.apiBaseUrl,
            `/api/${this.chainId}/markets/${this.marketAddress}`
          )
        );
        this.askPrices = data.askPrices;
        this.bidPrices = data.bidPrices;
      } catch (e) {
        // console.log(e)
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      }
    },
    clearTag: async function () {
      this.search = "";
      Object.values(this.filters).forEach((f) => {
        Object.keys(f).forEach((k) => {
          f[k] = false;
        });
      });
      for (const key in this.oFilter) {
        if (Object.hasOwnProperty.call(this.oNftType, key)) {
          this.oNftType[key] = false;
        }
      }
      this.oFilter = [];
      await this.handleFilterOk();
    },
    handleSearch: async function () {
      if (this.search) {
        if (ethers.utils.isAddress(this.search)) {
          let tokenIds = await this.loadNFTByAddr(this.search);
          tokenIds = (await this.loadAskByAddr(this.search)).concat(tokenIds);
          this.result = this.filterResult.filter((r) => {
            return tokenIds.indexOf(parseInt(r.id)) >= 0;
          });
        } else {
          const stext = this.search.toLocaleLowerCase();
          if (stext.startsWith("#")) {
            this.result = this.filterResult.filter((r) => {
              return `#${r.id}`.toLocaleLowerCase() == stext;
            });
          } else {
            this.result = this.filterResult.filter((r) => {
              return r.name.toLocaleLowerCase().indexOf(stext) >= 0;
            });
          }
        }
      } else {
        this.result = this.filterResult;
      }
      await this.handleSort();
    },
    loadNFTByAddr: async function (addr) {
      let nft = new NFT(this.nft, this.provider);
      this.iNFT = (await nft.balanceOf(addr)).toNumber();
      let to = this.iNFT <= 500 ? this.iNFT : 500;
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let tokenIds = await calls.nftOfOwnerByIndex(addr, 0, to);
      return tokenIds.map((t) => t.toNumber());
    },
    loadAskByAddr: async function (addr) {
      this.iAsk = (await this.market.askBalanceOf(addr)).toNumber();
      let to = this.iAsk <= 500 ? this.iAsk : 500;
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let tokenIds = await calls.askOfOwnerByIndex(addr, 0, to);
      return tokenIds.map((t) => t.toNumber());
    },
    handleSort: async function (orderBy) {
      if (orderBy) {
        this.orSelected = orderBy === "L2H" ? "H2L" : "L2H";
      }
      if (this.result.length > 0 && this.askPrices && this.bidPrices) {
        let _key = this.selected;
        if (["ID", "P", "O"].includes(_key)) {
          _key = `${this.selected}${this.orSelected}`;
          switch (_key) {
            case "IDL2H":
              utils.sortID(this.result);
              break;
            case "IDH2L":
              utils.sortID(this.result, true);
              break;
            case "PH2L":
              utils.sortPH2L(this.askPrices, this.result);
              break;
            case "PL2H":
              utils.sortPL2H(this.askPrices, this.result);
              break;
            case "OH2L":
              utils.sortOH2L(this.bidPrices, this.result);
              break;
            case "OL2H":
              utils.sortOL2H(this.bidPrices, this.result);
              break;
            default:
              // utils.sortID(this.result)
              utils.sortPH2L(this.askPrices, this.result);
              break;
          }
        } else if (_key) {
          let orderKey = "asc";
          if (this.orSelected === "H2L") {
            orderKey = "desc";
          }
          this.result = utils.orderBySaruBy(
            this.result,
            [this.selected],
            [orderKey]
          );
        } else {
          utils.sortPH2L(this.askPrices, this.result);
        }
      }
      this.items = [];
      this.limit = 12;
      this.page = 1;
      this.handleUrl();
      await this.loadItems();
    },
    handleUrl: function () {
      if (this.allData.length > 0) {
        const query = { ...this.$route.query };
        if (this.selected !== "ID") {
          query.srt = this.selected;
        } else {
          delete query.srt;
        }
        if (query.s !== this.search) {
          query.s = this.search;
        }

        if (query.o !== this.orSelected) {
          query.o = this.orSelected;
        }

        // if (this.oFilter && this.oFilter.length > 0) {
        //   delete query.fo;
        //   query.fo = this.oFilter.join("-");
        // }

        if (this.result.length !== this.allData.length) {
          query.flt = JSON.stringify(this.filters);
        } else {
          delete query.flt;
        }
        this.$router.replace({ query }).catch(() => {
          /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
        });
      }
    },
    handleFilterCancel: async function () {
      this.selects.reverse().forEach((it) => {
        this.filters[it[0]][it[1]] = !it[2];
      });
    },
    handleFilterOk: async function () {
      this.loadingItems = true;
      this.items = [];
      this.limit = 12;
      this.page = 1;
      let traits = {};
      Object.keys(this.filters).forEach((key) => {
        Object.keys(this.filters[key]).forEach((k) => {
          if (this.filters[key][k] === true) {
            traits[key] = traits[key] || [];
            traits[key].push(k);
          }
        });
      });

      const oFilter = [...this.oFilter];
      if (oFilter.length > 0) {
        this.filterResult = [...this.allData].filter((it) => {
          return oFilter.filter((attr) => it[attr]).length > 0;
        });
      } else {
        this.filterResult = this.allData;
      }

      if (Object.keys(traits).length > 0) {
        this.filterResult = this.filterResult.filter((d) => {
          let it = Object.keys(d).find((k) => {
            return (traits[k] || []).find((t) => t.trim() === d[k].trim());
          });
          if (it) {
            let tt = Object.keys(traits).filter((k) => {
              return (traits[k] || []).find((t) => t.trim() === d[k].trim());
            });
            return tt.length === Object.keys(traits).length;
          }
          return it;
        });
      }

      await this.handleSearch();
      this.loadingItems = false;
    },
    loadItems: async function () {
      if (this.totalSupply === 0) return;
      let total =
        this.allData.length !== this.result.length
          ? this.result.length
          : this.totalSupply;
      this.totalResults = total;
      let max = total > this.limit * this.page ? this.limit * this.page : total;

      let items = [];
      let mapPrices = [];
      for (let i = this.limit * (this.page - 1); i < max; i++) {
        let tokenId;
        let it = {};
        if (this.result.length > 0) {
          it = this.result[i];
          tokenId = (this.result[i] || {}).id;
          it.tokenId = tokenId;
          mapPrices.push(this.getPrices(it));
          items.push(it);
        } else {
          tokenId = await this.market.tokenByIndex(i);
          try {
            let uri = await this.market.tokenURI(tokenId);
            if (uri) {
              let { data } = await axios.get(this.utils.nftIpfsLink(uri));
              if (data) it = data;
            }
          } catch (e) {
            it = {};
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
          }
          it.tokenId = tokenId.toString();
          if (it) mapPrices.push(this.getPrices(it));
          items.push(it);
        }
      }
      await Promise.all(mapPrices);
      this.items.push(...items);
    },
    handleScroll: async function () {
      let d = document.documentElement;
      let offsetHeight = window.innerHeight;
      let offset = d.scrollTop + offsetHeight;
      let height = d.scrollHeight;
      let delta = 10;
      let total =
        this.allData.length > 0 ? this.result.length : this.totalSupply;
      if (
        offset + delta >= height &&
        !this.loadingItems &&
        this.limit * this.page < total
      ) {
        this.page = this.page + 1;
        this.loadingItems = true;
        await this.loadItems();
        this.loadingItems = false;
        this.handleScroll();
      }
    },
    async getPrices(it) {
      try {
        let bestBid = this.bidPrices ? this.bidPrices[it.tokenId] : 0;
        bestBid = bestBid
          ? ethers.BigNumber.from(bestBid)
          : (await this.market.getBestBid(it.tokenId))[1];
        bestBid = this.bestBidMarketPrice.gt(bestBid)
          ? this.bestBidMarketPrice
          : bestBid;
        let askPrice = this.askPrices ? this.askPrices[it.tokenId] : 0;
        askPrice = askPrice
          ? ethers.BigNumber.from(askPrice)
          : await this.market.getAskPrice(it.tokenId);
        if (bestBid.gt(askPrice)) {
          it.price = {
            label: "Top Bid",
            value: bestBid,
          };
        } else {
          it.price = {
            label: "Price",
            value: askPrice,
          };
        }
      } catch (e) {
        // eslint-disable-next-line
          }
    },
    async getMarketInfo() {
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let {
        totalSupply,
        exchangeFee,
        withdrawFee,
        treasuryFee,
        stakeRate,
        tvl,
        ftDecimals,
        ftSymbol,
        nftSymbol,
        nftName,
        marketTotalSupply,
        bestBidMarketPrice,
      } = await calls.getMarketInfo();
      this.totalSupply = totalSupply.toNumber();
      this.cSupply = totalSupply.toNumber();
      this.exchangeFee = exchangeFee;
      this.withdrawFee = withdrawFee;
      this.treasuryFee = treasuryFee;
      this.stakeRate = stakeRate;
      this.bestBidMarketPrice = bestBidMarketPrice;
      this.tvl = tvl;
      this.ftDecimals = ftDecimals;
      this.ftSymbol = ftSymbol;
      this.nftName = nftName;
      this.nftSymbol = nftSymbol;
      if (!totalSupply.eq(0) && !marketTotalSupply.eq(0)) {
        this.roi = utils.calROI(this.tvl, marketTotalSupply);
      }
      if (this.address) {
        let { price, share, isAuto, ROI } = await calls.getBidMarketInfo(
          this.address
        );
        this.lpPrice = price;
        this.lpShare = share;
        this.lpIsAuto = isAuto;
        this.lpROI = ROI;
      }
    },
    addClass1: function () {
      this.isAddClass1 = true;
      this.isAddClass2 = false;
      this.classActive = "columns-3";
    },
    addClass2: function () {
      this.isAddClass1 = false;
      this.isAddClass2 = true;
      this.classActive = "columns-4";
    },
    onChangeNft(key) {
      if (this.oNftType[key]) {
        this.oFilter.push(key);
      } else {
        this.oFilter = this.oFilter.filter((k) => k !== key);
      }
    },
    async onChangeTab(addr) {
      this.$store.dispatch("auth/onTabNftSelect", addr);
      this.loadingItems = true;
      this.loadingData = true;
      this.totalResults = 0;
      this.totalSupply = 0;
      this.result = [];
      this.filterResult = {};
      this.allData = [];
      this.page = 1;
      this.limit = 12;
      this.nft = addr;
      this.items = [];
      this.options = options;
      if (addr === this.nftItem) {
        this.options = optionItems;
      }
      this.initNft();
    },
  },
  mounted() {
    this.initNft();
  },
};
</script>
<style lang="scss">
.market-wrap {
  .hide {
    display: none !important;
  }
  .space-between {
    justify-content: space-between;
    align-items: center;
  }
  .collection-name {
    font-size: 2.3rem;

    text-transform: uppercase;
    color: #eb345f;
    cursor: pointer;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    font-weight: 600;
  }
  .collection-name.active {
    background-image: linear-gradient(0deg, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(180deg, #eb345f, #eb345f);
    color: #fff;
    border: none;
    margin-bottom: -1px;
    &::after {
      background: #091e42;
    }
  }

  .social-list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
    li {
      display: inline-block;
      margin-left: 10px;
      &.item {
        a {
          border-radius: 50%;
          border: 1px solid #434048;
        }
      }
      a {
        display: block;
        &:hover {
          .network,
          .telegram {
            path {
              fill: #98325f;
            }
          }
          .twitter {
            circle {
              fill: #98325f;
            }
          }
        }
      }
      &#my-nft {
        cursor: pointer;
        a {
          color: #fff;
          background-image: linear-gradient(
              to top,
              #503161,
              rgba(70, 50, 100, 0)
            ),
            linear-gradient(to bottom, #eb345f, #eb345f);
          border-bottom: 2px solid #eb345f !important;
          font-weight: 700;
          text-transform: uppercase;
          padding: 10px 30px;
          position: relative;
          &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            border-top: 15px solid #161347;
            border-right: 15px solid transparent;
            width: 0;
          }
        }
      }
    }
  }
  .card-item {
    min-height: 76px;
    width: calc(12.5% - 8px);
    justify-content: center;
    background-color: transparent;
    border: 1px solid #333364;
    border-radius: 0;

    @media (max-width: 991px) {
      width: calc(25% - 8px);
    }
    @media (max-width: 580px) {
      width: calc(50% - 5px);
    }
  }
  .t-size {
    color: #8685b5;
    font-weight: 600;
  }
  .v-size {
    font-size: 20px;
    font-weight: 600;
  }
  .about {
    &:after {
      content: "";
      width: calc(100% - 30px);
      height: 1px;
      background-color: #dfe1e6;
      margin: 20px auto 20px auto;
    }
  }
  .desc {
    font-weight: 400;
  }
  .filter-wrap {
    .group-filter {
      width: 80%;
      flex-wrap: nowrap;
    }
    .b-skeleton-input {
      border: none;
    }
    .custom-sekeleton-input {
      padding: 6px 12px;
      border: 1px solid #434048;
      border-radius: 8px;
      &.search-input {
        width: 45%;
      }
      &.select-input {
        width: 35%;
      }
    }
    .filter-button {
      background-color: transparent;
      color: inherit;
      border-color: #434048;
      border-radius: 8px;
      min-height: 56px;
      min-width: 120px !important;
      font-weight: 600;
      &:focus {
        box-shadow: none;
      }
      &:not(:disabled):not(.disabled):active:focus {
        box-shadow: none;
        background-color: #14101a;
        border-color: #434048;
        color: inherit;
      }
    }
    .search-input {
      position: relative;
      width: 50%;
      margin-left: 10px;
    }
    .icon-search {
      position: absolute;
      left: 18px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
      z-index: 5;
    }

    .sort-type {
      height: 56px;
      background-color: transparent;
      color: inherit;
      border: 1px solid #434048 !important;
      border-radius: 8px;
      cursor: pointer;
      margin-bottom: 0;
    }

    #search-nft {
      height: 56px;
      border-radius: 8px;
      padding-left: 45px;
      background-color: transparent;
      border-color: #434048;
      color: #fff;
      font-weight: 600;
      &::-webkit-input-placeholder {
        /* Edge */
        color: #fff;
        font-weight: 600;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer */
        color: #fff;
        font-weight: 600;
      }

      &::placeholder {
        color: #fff;
        font-weight: 600;
      }
    }
    .sort {
      height: 56px;
      border-radius: 8px;
      width: 35%;
      margin-left: 10px;
      background-color: transparent;
      border-color: #434048;
      color: #fff;
      text-transform: uppercase;
      font-weight: 600;
      option {
        cursor: pointer;
        background: #20132f;
        &:hover {
          background-color: #482f66;
        }
      }
      optgroup {
        background: #20132f;
      }
    }
    .icon-position {
      position: absolute;
      right: 15px;
      top: 0;
    }
    .grid-layout {
      justify-content: center;
      width: 120px;
      .input-group-text {
        height: 56px;
        width: 56px;
        border-radius: 0;
        background-color: transparent;
        justify-content: center;
        cursor: pointer;
        color: #fff;
        border-color: #434048;
        &:first-child {
          border-right: 0;
        }
        &.active {
          background-image: linear-gradient(0deg, #503161, rgba(70, 50, 100, 0)),
            linear-gradient(180deg, #eb345f, #eb345f);
        }
      }
    }
    @media (max-width: 767px) {
      .group-filter {
        width: 100%;
        flex-wrap: wrap;
        .search-input,
        .sort {
          width: 100%;
          margin-top: 20px;
          margin-left: 0;
        }
      }
      .custom-sekeleton-input {
        padding: 6px 12px;
        border: 1px solid #434048;
        border-radius: 8px;
        &.search-input,
        &.select-input {
          width: 100%;
          margin-top: 20px;
        }
      }
      .sort-type {
        margin-top: 20px;
      }
    }
  }
  .atribute-filter {
    .badge-custom {
      background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
        linear-gradient(to bottom, #eb345f, #eb345f);
      border-radius: 5px;
      padding: 4px 16px;
      margin-bottom: 5px;
      display: inline-block;
    }
    .b-form-tag-remove {
      margin-left: 0.5em;
      width: 15px;
      height: 15px;
      background-color: #9b9b9b;
      line-height: 15px;
      border-radius: 16px;
    }
    .filter-clear {
      > div {
        background-color: #552d65;
        color: #fff;
        padding: 4px 16px;
        border-radius: 5px;
        font-size: 12px;
        margin-bottom: 5px;
        text-decoration: none;
        display: flex;
        align-items: center;
        span {
          margin-left: 5px;
        }
      }
      &:hover {
        text-decoration: none;
        > div {
          background-color: #613672;
        }
      }
    }
  }
  .result {
    padding: 4px 16px;
    border-radius: 5px;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    font-size: 12px;
    margin-bottom: 5px;
    color: #fff;
  }
  .no-item {
    text-align: center;
    width: 100%;
    display: block;
    color: #8d3260;
    margin-top: 30px;
    margin-bottom: 60px;
    img {
      max-width: 80px;
    }
  }
  .nft-item {
    min-width: 297px;
    margin: 0 10px 24px 10px;
    background-color: transparent;
    border-color: transparent;
    transition: all 0.35s ease;
    cursor: pointer;
    .top-icon {
      height: 8px;
      width: 40%;
      transform: skew(-50deg);
      display: block;
      background-color: #552d65;
      position: absolute;
      left: 28%;
      top: 0;
    }
    // &:hover{
    //     background-color: #fff;
    //     box-shadow: 0px 0px 8px 2px #e9e9e9;
    // }
    &:before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      z-index: 0;
      left: 0;
      display: block;
      background: #434048;
      clip-path: polygon(
        calc(68% - 1px) calc(4% - 2px),
        calc(74% - 3px) 0,
        calc(93% + 2px) 0,
        100% calc(5% - 4px),
        100% calc(94% + 4px),
        calc(94% + 2px) 100%,
        0 100%,
        0px calc(10% - 3px),
        calc(11% - 1px) calc(4% - 2px)
      );
    }
    > a {
      color: inherit;
      position: relative;
      clip-path: polygon(
        68% 4%,
        74% 0,
        93% 0,
        100% 5%,
        100% 94%,
        94% 100%,
        0 100%,
        0 10%,
        11% 4%
      );
      border: 2px solid #434048;
      background-color: #16101c;
      border-radius: 0;
      padding-left: 15px;
      padding-right: 15px;
      &:hover {
        text-decoration: none;
      }
      img {
        margin-top: 45px;
      }
      .b-skeleton-img {
        margin-top: 45px;
        height: 260px;
      }
    }
    &:hover {
      &:before {
        background-color: #fff;
      }
      .top-icon {
        background-color: #eb345f;
      }
      > a {
        border-color: #fff;
      }
      .nft-title,
      .nft-price-value {
        color: #eb345f;
      }
    }
    .card-body {
      padding: 16px 0;
    }
    .is-flex {
      justify-content: space-between;
    }
    .nft-head {
      width: 61%;
    }
    .nft-price {
      width: 39%;
    }
    .nft-acc {
      font-size: 12px;
      margin-bottom: 0;
      color: #66636a;
      font-weight: 600;
      line-height: 16px;
    }
    .nft-title {
      font-size: 30px;
      margin-bottom: 0;
    }
    .nft-price-text {
      font-size: 12px;
      margin-bottom: 0;
      color: #66636a;
      font-weight: 600;
      text-align: right;
    }
    .nft-price-value {
      font-size: 30px;
      text-align: right;
      margin-bottom: 0;
    }
    @media (max-width: 560px) {
      width: calc(100% - 20px) !important;
      > a {
        img {
          margin-top: 55px;
        }
      }
    }
  }
}
.columns-4 {
  .is-flex {
    justify-content: center;
  }
  .nft-item {
    width: calc(25% - 20px);
  }
}
.columns-3 {
  .is-flex {
    justify-content: center;
  }
  .nft-item {
    width: calc(33.33% - 20px);
  }
}

@media (max-width: 767) {
  .lbl-nft {
    display: none;
  }
}

#filter-nft {
  .custom-switch {
    cursor: pointer;
    .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #862746;
    }
    .custom-control-input:checked ~ .custom-control-label::after {
      background-color: #eb345f;
      transform: translateX(1.75rem);
    }
    .custom-control-label::before,
    .custom-control-label::after {
      border-radius: 0;
    }
    .custom-control-label::after {
      background-color: #605e62;
    }
    .custom-control-label::before {
      background-color: #433d4b;
      border: none;
      width: 2.75rem;
    }
    .custom-control-label {
      span {
        margin-left: 25px;
      }
    }
  }
  .btn-cancel {
    padding: 10px 30px;
    border-radius: 8px;
    border: none;
  }
  .btn-success {
    padding: 10px 35px;
    background-color: #9d22c1;
    color: #fff;
    border-radius: 8px;
    border: none;
    font-weight: 700;
  }
  .btn-cancel,
  .btn-success {
    &:before {
      border-top-color: #3a2a55;
    }
  }
}

#sb-filter-nft {
  background-image: linear-gradient(180deg, #030204, rgba(70, 50, 100, 0)),
    linear-gradient(0deg, #433060, #433060);
  font-family: "Source Sans Pro", sans-serif;
  .sb-body {
    color: #ffffff;
    font-family: "Source Sans Pro", sans-serif;
  }

  .custom-switch {
    cursor: pointer;
    .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #862746;
    }
    .custom-control-input:checked ~ .custom-control-label::after {
      background-color: #eb345f;
      transform: translateX(1.75rem);
    }
    .custom-control-label::before,
    .custom-control-label::after {
      border-radius: 0;
    }
    .custom-control-label::after {
      background-color: #605e62;
    }
    .custom-control-label::before {
      background-color: #433d4b;
      border: none;
      width: 2.75rem;
    }
    .custom-control-label {
      span {
        margin-left: 25px;
      }
    }
  }
  .fsider-bar {
    display: flex;
    justify-items: center;
    item .btn-cancel {
      padding: 10px 30px;
      border-radius: 8px;
      border: none;
    }
    .btn-success {
      padding: 10px 35px;
      background-color: #9d22c1;
      color: #fff;
      border-radius: 8px;
      border: none;
      font-weight: 700;
    }
    .btn-cancel,
    .btn-success {
      &:before {
        border-top-color: #3a2a55;
      }
    }
  }
}

#import-token-alert {
  .modal-dialog {
    max-width: 520px;
  }
}
#your-nft {
  .modal-content {
    clip-path: polygon(0 7%, 3% 0, 100% 0%, 100% 93%, 97% 100%, 0 100%);
  }
  .nav-tabs {
    border-bottom-color: #434048;
  }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    color: #fff;
    border: none;
    border-bottom: 2px solid #eb345f;
  }
  .nav-tabs .nav-link:hover,
  .nav-tabs .nav-link:focus {
    border-color: #434048;
  }
}
.saru-tab {
  border-bottom: 1px solid #434048 !important;
}
</style>
